module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "assets/images/logo.png" + "?" + Date.now();